import { mdiAccountGroupOutline } from '@mdi/js'

export default [
  {
    title: 'Committees',
    icon: mdiAccountGroupOutline,
    resource: 'Tenant',
    children: [
      {
        title: 'Committee List',
        to: 'feature-committee-list',
        resource: 'Tenant',
      },
      {
        title: 'Committee Reports',
        to: 'feature-committee-reports-list',
        resource: 'Tenant',
      },
    ],
  },
]
